import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import DEFINE, { UPLOAD_DIRECTORY, VALIDATE_ENUM, DETAIL_ACTIONS, FEATURE_FLAGS, PATHS, DATE_TIME_FORMAT, INSTALLMENT as INSTALLMENT_ENUM } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import { message, Icon, Input as AntInput } from 'antd';
import AntSelect, { AntOption } from '../../../common/component/AntSelect'
import Input from '../../../common/component/Input';
import Wrapper from './../../../common/component/Wrapper';
import Button from './../../../common/component/Button';
import TagSearch from './../../../common/component/TagSearch';
import RichTextEditor, { ClassicEditor } from '../../../common/component/RichTextEditor';
import TextArea from '../../../common/component/TextArea';
import UploadImage from '../../../common/component/UploadImage';
import { omit, cloneDeep, merge, every, toArray, get, find, isEqual } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import VinWonder, { siteCodes } from '../../../../../models/VinWonder';
import moment from 'moment';
import './VinWonderDetail.less';

const defaultValue = {
    action: DETAIL_ACTIONS.CREATE,
    data: new VinWonder(),
    fileMultiple: [],
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
    isUpload: false,
    isUploadMultiple: false,
    thumbImage: {},
    _tagSKUs: []
};
let permissionActions = [];
class VinWonderDetail extends Component {

    state = cloneDeep(defaultValue);

    componentDidMount() {
        const { match } = this.props;
        
        this.props.getVinWonderSites();
        this.props.getVinWonderTypes();
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.VIN_WONDER);
        this.setState({ fileMultiple: [] });
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE, data: cloneDeep(defaultValue.data) });
            this.props.onGetUpdate({ id: match.params.id, props: this.props });
            this.props.getTagBySku(match.params.id);
        }else{
            this.props.getAllTagGroup();
        }
    }

    componentWillUnmount(){
        this.props.setTagBySku([]);
        this.props.setAllTagGroup([]);
    }

    validation = (field, reload) => {
        const { t, dataUpdate } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                minImage: { images: t('validation.image1pic') },
                required: {
                    name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.name`)),
                    siteCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.siteCode`)),
                    type: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.type`)),
                    thumbImage: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.thumbImage`)),
                    description: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.description`)),
                    saleStartDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.saleStartDate`)),
                    saleEndDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.saleEndDate`)),
                },
                isNumber: { order: Func.formatValidation(t('validation.statusCode.code.2'), t(`item.vinWonder.order`)) }
            };
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
            }
            if(this.state.action === DETAIL_ACTIONS.UPDATE) {
                validate.required.urlSlug = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonder.urlSlug`));
            }
            let valueValidate = {
                minImage: { images: 1 },
            };
            if(this.state.data.installmentFee || this.state.data.installmentLimit) {
                validate.required.installmentFee = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentFee`))
                validate.required.installmentLimit = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentLimit`))
            }
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.vinWonders.isSubmit,
            isGetItem: nextProps.vinWonders.isGetItem,
            isUpload: nextProps.file.isFetching,
            isUploadMultiple: nextProps.file.isFetchingMultiple,
            isFetchingUpdate: nextProps.vinWonders.isFetchingUpdate
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.file !== prevProps.file) {
            if (this.props.file.file) {
                let fileMulti = this.state.fileMultiple;
                let fileNameMulti = this.state.data.images ? this.state.data.images : [];
                let oldThumbImage = this.state.thumbImage;
                let thumbImageName = this.state.data.thumbImage ? this.state.data.thumbImage : "";
                if (this.props.file.file.type === 1) {
                    fileMulti.push(this.props.file.file.data);
                    fileNameMulti.push(this.props.file.file.data.fileName)
                } else if (this.props.file.file.type === 0) {
                    oldThumbImage = this.props.file.file.data;
                    thumbImageName = this.props.file.file.data.fileName;
                }
                this.setState({
                    file: this.props.file.file.type === 0 ? this.props.file.file : undefined,
                    data: merge(this.state.data, {
                        thumbImage: thumbImageName,
                        images: fileNameMulti
                    }),
                    fileMultiple: fileMulti,
                    thumbImage: oldThumbImage || undefined,
                });
            }
        }
        if (this.props.vinWonders.detail !== prevProps.vinWonders.detail) {
            let { imagesView, thumbImageName, thumbImageView } = this.props.vinWonders.detail.vinWonder;
            let data = this.props.vinWonders.detail.vinWonder;
            let arrayImages = [];
            let fileName = [];
            imagesView.map(i => {
                arrayImages.push({ fileUrl: i.fileUri ? i.fileUri : i.fileUrl, fileName: i.filename });
                fileName.push(i.filename);
            });
            this.setState({
                data: merge(data, {
                    images: fileName,
                    thumbImage: (thumbImageView && thumbImageView.filename) || thumbImageName,
                    thumbImageView: thumbImageView
                }),
                checkData: {
                    endDate: this.props.vinWonders.detail.endDate,
                    saleStartDate: this.props.vinWonders.detail.saleStartDate,
                },
                fileMultiple: arrayImages,
                thumbImage: thumbImageView || undefined,
            })
        }
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            if(this.props.tagGroupState.allTagGroups && !isEqual(prevProps.tagGroupState.allTagGroups, this.props.tagGroupState.allTagGroups)){
                const dataTmp = (this.props.tagGroupState.allTagGroups || []).map((item, index) => {
                    return {
                        tagGroup: item,
                        tagList: [],
                        index: index
                    }
                });
                this.setState({_tagSKUs : dataTmp});
            }
        } 
        else if(this.props.tagGroupDetailState.tagGroupSKU && !isEqual(prevProps.tagGroupDetailState.tagGroupSKU, this.props.tagGroupDetailState.tagGroupSKU)) {
            const dataTmp = (this.props.tagGroupDetailState.tagGroupSKU || []).map((item, index) => {
                return {
                    ...item,
                    tagList: (item.tagList || []).map(item => {return {...item, isInsert: true}}),
                    index: index
                }
            });
            this.setState({_tagSKUs : dataTmp});
        }
    }

    onChange = (e, tag) => {
        const data = this.state.data;
        if (tag) {
            let eTmp = e;
            if(tag === 'siteCode'){
                eTmp = e.code;
                data['siteCodeString'] = e.mappingCode || '';
            }
            data[tag] = eTmp;
            this.setState({ data });
            this.validation(tag, true);
        } else {
            let params = Func.getValueForm(e);
            data[params.name] = typeof params.value === 'string' ? params.value.trimLeft() : params.value;
            this.setState({ data });
            this.validation(params.name, true)
        }
    };

    onChangeUrlSlug = (e) => {
        const value = Func.formatUrlSlug(e.target.value);
        return this.onChange(value, 'urlSlug');
    }

    onSubmit = (e) => {
        e.preventDefault();
        let { action, data, _tagSKUs } = this.state
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (data.acceptCheck) {
                let newData = this.state.data;
                let skuTags = {};
                if(_tagSKUs && _tagSKUs.length > 0){
                    let lstInserts = [];
                    let lstDeletes = [];
                    _tagSKUs.map(item => {
                        if(item.tagList){
                            (item.tagList || []).map(it => {
                                if(it.isInsert){
                                    lstInserts.push(it.id)
                                }else{
                                    lstDeletes.push(it.id)
                                }
                            });
                        }
                    })
                    skuTags = {
                        inserts: lstInserts,
                        deletes: lstDeletes,
                        type: 2
                    }
                }

                if (data.saleStartDate.isAfter(data.saleEndDate)) {
                    message.error(this.props.t('validation.statusCode.code.10007'));
                    return false;
                }

                if(data.blackOutStartDate && data.blackOutEndDate) {
                    if (data.blackOutStartDate.isAfter(data.blackOutEndDate)) {
                        message.error(this.props.t('validation.statusCode.code.10007'));
                        return false;
                    }
                }

                if (action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE) {
                    this.saveVinWonder({ data: newData, props: this.props, skuTags:  skuTags}, this.props.onCreateVinWonder);
                } else if (this.state.action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE) {
                    let newData = this.state.data;
                    if (typeof newData.thumbImage !== 'string') {
                        newData.thumbImage = undefined;
                    }
                    if(_tagSKUs.length > 0){
                        const { match } = this.props;
                        skuTags = {
                            skuId: match.params.id,
                            ...skuTags
                        };
                    }
                    this.saveVinWonder({ data: merge(newData, { id: this.state.data.id }), props: this.props, skuTags: skuTags }, this.props.onUpdateVinWonder);
                    
                }
                
            } else {
                message.error(i18n.t('item.vinWonder.acceptInfo'))
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    uploadFileMultiple = (file) => {
        let data = file.target.files;
        let lengthImage = this.state.fileMultiple;
        if (data.length > 5) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 5));
            return false;
        }
        if ((lengthImage.length + data.length) > 5) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 5));
            return false;
        }
        this.setState({
            isUploadMultiple: true,
        });
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(data).map((i) => {
            if (imageValidation.includes(data[i].type)) {
                this.props.onUploadFile({ file: data[i], directory: UPLOAD_DIRECTORY.IMAGES, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    };

    saveVinWonder = (params, updateFunc) => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onSaveTranslate(params.data)
        } else {
            updateFunc(params)
        }
    }

    onShowTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        data.setData();
        this.setState({ data, action: DETAIL_ACTIONS.TRANSLATE });
        this.setImageView(data);
    }

    onExitTranslate = () => {
        const data = cloneDeep(this.state.data);
        const action = DETAIL_ACTIONS[data.id ? 'UPDATE' : 'CREATE'];
        data.setTranslate(undefined, true);
        data.setData();
        this.setState({ data, action });
        this.setImageView(data);
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.VIN_WONDER.LIST.path);
        }
    }

    onSaveTranslate = (data) => {
        data = data || this.state.data;
        const translateFunction = data.translate.id ? this.props.updateVinWonderTranslate : this.props.createVinWonderTranslate;
        translateFunction(data, data.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        this.props.deleteVinWonderTranslate(data, { id: data.id });
    }

    setImageView = (detail) => {
        let arrayImages = [];
        let fileName = [];
        let thumbImageName = detail.thumbImage;
        let thumbImageView = detail.thumbImageView;
        let listImages = detail.imagesView;
        listImages.map(i => {
            arrayImages.push({ fileUrl: i.fileUri ? i.fileUri : i.fileUrl, fileName: i.filename });
            fileName.push(i.filename);
        });

        this.setState({
            data: merge(detail, {
                images: fileName,
                thumbImage: (thumbImageView && thumbImageView.filename) || thumbImageName,
                thumbImageView: thumbImageView,
            }),
            fileMultiple: arrayImages,
            thumbImage: thumbImageView || undefined,
        })
    }

    uploadFile = (file) => {
        let data = this.state.data;
        data.thumbImage = undefined;
        this.setState({
            isUpload: true,
            data: data
        });
        this.props.onUploadFile({ file: file.target.files[0], directory: UPLOAD_DIRECTORY.VIN_WONDER_THUMB, isFile: 1 });
    };

    render() {
        const { t, vinWonders } = this.props;
        const { data, validation, isSubmit, isGetItem, action, isUpload, file, checkData, isUploadMultiple, _tagSKUs } = this.state;
        const isInstallment = data.installmentFee || data.installmentLimit
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="vin-wonder-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'vinWonders'}
                            titleHeader={
                                action === DETAIL_ACTIONS.CREATE ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.vinWonder.title')}`))
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.vinWonder.title')}`))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={data.translations}
                                    current={data.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange(language.code, 'languageCode')}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            isGetItem={isGetItem}
                            activeComponent={true}
                            onChangeActive={this.onChange}
                            titleActiveComponent={t(`item.vinWonder.acceptcheck`)}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            submitButtonRight={true}
                            statusActiveName={`acceptCheck`}
                            statusActive={data.acceptCheck}
                            showActiveComponent={true}
                            // additionalButton={this.renderFooterButtons()}
                        >
                            <HMS.FormWrapperItem>
                                <Wrapper className="footer-manage-buttons">
                                    <Fragment>
                                        <Button className="btn mr-2" icon="bars" disabled={action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE} onClick={this.onClickManageVinWonderTickets}>{this.props.t(`navigation.vinWonderTickets`)}</Button>
                                        <Button className="btn mr-2" icon="dollar" disabled={action === DETAIL_ACTIONS.CREATE || action === DETAIL_ACTIONS.TRANSLATE} onClick={this.onClickManageCustomPrices}>{this.props.t(`navigation.customPrices`)}</Button>
                                    </Fragment>
                                </Wrapper>
                            </HMS.FormWrapperItem>
                            <HMS.FormWrapperItem>
                                <HMS.HeaderComponent title={t('item.vinWonder.showInfo.info')} className="col-md-12 mb-3 p-2"
                                    style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                { (action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE ) &&
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        dataValidation={data.vinWonderCode}
                                        validation={validation.urlSlug}
                                        labelTitle={t(`item.vinWonder.vinWonderCode`)}
                                        disabled
                                    >
                                        <Input type="text"
                                            disabled
                                            autoComplete="off"
                                            className="form-control" name="vinWonderCode"
                                            value={Func.checkUndefine(data.vinWonderCode)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                }
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        // isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.vinWonder.name`)}
                                    >
                                        <Input type="text"
                                            autoComplete="off"
                                            className="form-control" name="name" onChange={this.onChange}
                                            value={data.name ? data.name : ""} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.siteCode}
                                        validation={validation.siteCode}
                                        labelTitle={t(`item.vinWonder.siteCode`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        {
                                            vinWonders.vinWonderSites && vinWonders.vinWonderSites.length > 0 && 
                                            <AntSelect className="select-site-code"
                                                showArrow showSearch
                                                placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.vinWonder.siteCode")).toLowerCase())}
                                                value={data.siteCode}
                                                onChange={this.onChangeSiteCode}
                                                style={{ width: '100%' }}
                                                disabled={action === DETAIL_ACTIONS.UPDATE}
                                                filterOption={this.selectFilterSearch}
                                            >
                                                {vinWonders.vinWonderSites.map(d => (
                                                    <AntOption disabled={action === DETAIL_ACTIONS.UPDATE} key={d.code} value={d.code}>{d.name}</AntOption>
                                                ))}
                                            </AntSelect>
                                        }
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                { (action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE ) &&
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.urlSlug}
                                        validation={validation.urlSlug}
                                        labelTitle={t(`item.vinWonder.urlSlug`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input type="text"
                                            autoComplete="off"
                                            className="form-control" name="urlSlug" onChange={this.onChangeUrlSlug}
                                            value={Func.checkUndefine(data.urlSlug)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                }
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        // isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.shortDescription}
                                        validation={validation.shortDescription}
                                        labelTitle={t(`item.vinWonder.shortDescription`)}
                                    >
                                        <TextArea
                                            className="form-control" name="shortDescription" onChange={this.onChange}
                                            value={Func.checkUndefine(data.shortDescription)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.order}
                                                validation={validation.order}
                                                labelTitle={t(`item.vinWonder.order`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Input type="text"
                                                    autoComplete="off"
                                                    placeholder=''
                                                    className="form-control"
                                                    name="order"
                                                    onChange={this.onChange}
                                                    value={data.order} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                // isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.limitNumberOfSalesPerUser}
                                                validation={validation.limitNumberOfSalesPerUser}
                                                labelTitle={t(`item.group.limitNumberOfSalesPerUser`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Input type="text"
                                                    autoComplete="off"
                                                    className="form-control" name="limitNumberOfSalesPerUser"
                                                    onChange={this.onChange}
                                                    value={data.limitNumberOfSalesPerUser ? Func.formatMoney(data.limitNumberOfSalesPerUser.toString()) : ""} />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.type}
                                                validation={validation.type}
                                                labelTitle={t(`item.vinWonder.type`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                {
                                                    vinWonders.vinWonderTypes && vinWonders.vinWonderTypes.length > 0 && 
                                                    <AntSelect className="select-site-code"
                                                        showArrow showSearch
                                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.vinWonder.type")).toLowerCase())}
                                                        value={data.type}
                                                        onChange={this.onChangeTypeCode}
                                                        style={{ width: '100%' }}
                                                        disabled={action === DETAIL_ACTIONS.UPDATE}
                                                        filterOption={this.selectFilterSearch}
                                                    >
                                                        {vinWonders.vinWonderTypes.map(d => (
                                                            <AntOption disabled={action === DETAIL_ACTIONS.UPDATE} key={d.id} value={d.id}>{d.name}</AntOption>
                                                        ))}
                                                    </AntSelect>
                                                }
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12" style={{ position: 'relative' }}>
                                    <HMS.HeaderComponent title={t('item.vinWonder.showInfo.available')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <div className="row align-items-center mb-3">
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <HMS.FormWrapperInputComponent
                                                        isRequired={true}
                                                        isValidation={true}
                                                        dataValidation={data.saleStartDate}
                                                        validation={validation.saleStartDate}
                                                        labelTitle={t(`item.vinWonder.saleStartDate`)}
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <HMS.DatePickerComponent
                                                                    disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                                    onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                                    name={'saleStartDate'}
                                                                    format={DATE_TIME_FORMAT.SHORT_DATE}
                                                                    value={data.saleStartDate || null}
                                                                    placeholder=""
                                                                    style={{ width: '100%' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                                <div className="col-md-6">
                                                    <HMS.FormWrapperInputComponent
                                                        isRequired={true}
                                                        isValidation={true}
                                                        dataValidation={data.saleEndDate}
                                                        validation={validation.saleEndDate}
                                                        labelTitle={t(`item.vinWonder.saleEndDate`)}
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <HMS.DatePickerComponent
                                                                    disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                                    onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                                    name={'saleEndDate'}
                                                                    format={DATE_TIME_FORMAT.SHORT_DATE}
                                                                    value={data.saleEndDate || null}
                                                                    placeholder=""
                                                                    style={{ width: '100%' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                                <div className={`col-md-6`}>
                                                    <HMS.FormWrapperInputComponent>
                                                        <HMS.CheckboxComponent
                                                            name='isAvailable'
                                                            className={`mr-4`}
                                                            onChange={this.onChange}
                                                            checked={data.isAvailable}>{t(`item.vinWonder.isAvailable`)}
                                                        </HMS.CheckboxComponent>
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                                <div className={`col-md-6`}>
                                                    <HMS.FormWrapperInputComponent>
                                                        <HMS.CheckboxComponent
                                                            name='isSpecial'
                                                            className={`mr-4`}
                                                            onChange={this.onChange}
                                                            checked={data.isSpecial}>{t(`item.vinWonder.isSpecial`)}
                                                        </HMS.CheckboxComponent>
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                            <div className="col-md-6">
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.vinWonder.blackOutStartDate`)}
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <HMS.DatePickerComponent
                                                                    disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                                    onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                                    showTime
                                                                    name={'blackOutStartDate'}
                                                                    format={DATE_TIME_FORMAT.DATE_TIME}
                                                                    value={data.blackOutStartDate || null}
                                                                    placeholder=""
                                                                    style={{ width: '100%' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                                <div className="col-md-6">
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.vinWonder.blackOutEndDate`)}
                                                    >
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <HMS.DatePickerComponent
                                                                    disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                                    onChange={data => this.onChange({ ...data, value: data.fullValue })}
                                                                    showTime
                                                                    name={'blackOutEndDate'}
                                                                    format={DATE_TIME_FORMAT.DATE_TIME}
                                                                    value={data.blackOutEndDate || null}
                                                                    placeholder=""
                                                                    style={{ width: '100%' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                                <div className="col-md-12">
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.vinWonder.blackOutReason`)}
                                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                                    >
                                                        <Input type="text"
                                                            autoComplete="off"
                                                            className="form-control" name="blackOutReason" onChange={this.onChange}
                                                            value={data.blackOutReason ? data.blackOutReason : ""} />
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {action === DETAIL_ACTIONS.TRANSLATE &&
                                        <div className="bg-white form-input-visible-hide-backdrop"></div>
                                    }
                                </div>
                            </HMS.FormWrapperItem>
                            <HMS.FormWrapperItem>
                                <div className='col-md-12' style={{ overflow: 'hidden' }}>
                                    <HMS.HeaderComponent title={t('item.group.showInfo.installment')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflow: 'hidden' }}>
                                        <div className="col-md-3 p-0 pr-2">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={isInstallment ? true : false}
                                                isValidation={true}
                                                dataValidation={data.installmentFee}
                                                validation={validation.installmentFee}
                                                labelTitle={t(`item.group.installmentFee`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Wrapper style={{ display: 'flex' }}>
                                                    <AntSelect
                                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.installmentFee")).toLowerCase())}
                                                        value={data.installmentFee}
                                                        onChange={(e) => this.onChange(e, 'installmentFee')}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <AntOption key={0} value=''>{t(`item.group.installmentFee_enum.UN_KNOW`)}</AntOption>
                                                        {INSTALLMENT_ENUM.INSTALLMENT_FREE.map((value, index) => {
                                                            return <AntOption key={index + 1} value={value}>{t(`item.group.installmentFee_enum.${value}`)}</AntOption>
                                                        })}
                                                    </AntSelect>
                                                </Wrapper>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-3 p-0 pl-2">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={isInstallment ? true : false}
                                                isValidation={true}
                                                dataValidation={data.installmentLimit}
                                                validation={validation.installmentLimit}
                                                labelTitle={t(`item.group.installmentLimit`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Wrapper style={{ display: 'flex' }}>
                                                    <AntSelect
                                                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.installmentLimit")).toLowerCase())}
                                                        value={data.installmentLimit}
                                                        onChange={(e) => this.onChange(e, 'installmentLimit')}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <AntOption key={0} value=''>{t(`item.group.installmentLimit_enum.UN_KNOW`)}</AntOption>
                                                        {Object.keys(INSTALLMENT_ENUM.INSTALLMENT_LIMIT).map((value, index) => {
                                                            return <AntOption key={index + 1} value={INSTALLMENT_ENUM.INSTALLMENT_LIMIT[value]}>{t(`item.group.installmentLimit_enum.${value}`)}</AntOption>
                                                        })}
                                                    </AntSelect>
                                                </Wrapper>
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                            </HMS.FormWrapperItem>
                            <HMS.FormWrapperItem>
                                <div className="col-md-12">
                                    <HMS.HeaderComponent title={t('item.vinWonder.showInfo.introduce')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflow: 'hidden' }}>
                                        <div className="col-md-6 p-0 pr-2">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={data.description}
                                                validation={validation.description}
                                                labelTitle={t(`item.vinWonder.description`)}
                                            >
                                                <RichTextEditor
                                                    editor={ClassicEditor}
                                                    config={{ uploadDirectory: UPLOAD_DIRECTORY.VIN_WONDER_THUMB }}
                                                    data={this.state.data.description || ""}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.onChange(data, "description")
                                                    }}
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                        <div className="col-md-6 p-0 pr-2">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.vinWonder.conditionOfUse`)}
                                            >
                                                <RichTextEditor
                                                    editor={ClassicEditor}
                                                    config={{ uploadDirectory: UPLOAD_DIRECTORY.VIN_WONDER_THUMB }}
                                                    data={this.state.data.conditionOfUse || ""}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        this.onChange(data, "conditionOfUse")
                                                    }}
                                                />
                                            </HMS.FormWrapperInputComponent>
                                        </div>
                                    </div>
                                </div>
                            </HMS.FormWrapperItem>
                            <HMS.FormWrapperItem>
                                <div className={`col-md-6`}>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.thumbImage}
                                        validation={validation.thumbImage}
                                        labelTitle={t(`item.vinWonder.thumbImage`)}
                                    >
                                        <UploadImage
                                            multiple={false}
                                            loading={isUpload}
                                            thumbnailSize="100%"
                                            buttonSize={120}
                                            thumbnailStyle={{ maxHeight: 250 }}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFile}
                                            onRemoveThumbnail={this.removeThumbImage}
                                            thumbnails={this.state.thumbImage ? this.getThumbSources([this.state.thumbImage]) : undefined} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-6">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.images}
                                        validation={validation.images}
                                        labelTitle={t(`item.vinWonder.images`)}
                                    >
                                        <UploadImage
                                            multiple={true}
                                            loading={isUploadMultiple}
                                            thumbnailSize={120}
                                            buttonSize={120}
                                            disabledUpload={this.showImageMultiple().length > 6}
                                            uploadText={t('item.tour.uploadFile')}
                                            loadingText={t('item.tour.uploading')}
                                            onChange={this.uploadFileMultiple}
                                            onRemoveThumbnail={(src, index) => this.removeImage(this.getImageThumbBySrc(src))}
                                            thumbnails={this.getThumbSources(this.state.fileMultiple)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                            <HMS.FormWrapperItem>
                                <div className={`col-md-8`}>
                                    <TagSearch 
                                        {...this.props}
                                        tagSKUs={_tagSKUs}
                                        loadDataTagGroup={this._loadDataTagGroup}
                                        onAddTagGroup={this._onAddTagGroup}
                                    />
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }

    renderFooterButtons() {
        const { action } = this.state;

        return (
            <Wrapper className="footer-manage-buttons">
                {action !== DETAIL_ACTIONS.TRANSLATE &&
                    <Fragment>
                        <Button className="btn mr-2" icon="bars" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageVinWonderTickets}>{this.props.t(`navigation.vinWonderTickets`)}</Button>
                        <Button className="btn mr-2" icon="dollar" disabled={this.state.action === DETAIL_ACTIONS.CREATE} onClick={this.onClickManageCustomPrices}>{this.props.t(`navigation.customPrices`)}</Button>
                    </Fragment>
                }
            </Wrapper>
        )
    }

    _loadDataTagGroup = (id)=> {
        const { data } = this.state;
        this.props.getTagInTagroup({
            tagGroupId: id,
            languageCode: data.languageCode || 'vi-VN'
        });
    }

    _onAddTagGroup = (value, index)=> {
        const { _tagSKUs } = this.state;
        if(_tagSKUs.length > 0){
            _tagSKUs[index].tagList = value;
            this.setState({ _tagSKUs })
        }
    }

    onClickManageCustomPrices = () => {
        const { data } = this.state;
        const path = Func.getPathWithParams(PATHS.VIN_WONDER_PRICE.LIST.path, { vin_wonder_id: data.id });
        this.props.history.push(path);
    }

    onClickManageVinWonderTickets = () => {
        const { data } = this.state;
        const path = Func.getPathWithParams(PATHS.VIN_WONDER_TICKET.LIST.path, { vin_wonder_id: data.id });
        this.props.history.push(path);
    }

    onChangeSiteCode = (id) => {
        const { vinWonders } = this.props;
        const siteCode = find(vinWonders.vinWonderSites || [], item => item.code === id);
        return siteCode && this.onChange(siteCode, 'siteCode');
    }

    onChangeTypeCode = (id) => {
        const { vinWonders } = this.props;
        const typeTmp = find(vinWonders.vinWonderTypes || [], item => item.id === id);
        return typeTmp && this.onChange(typeTmp.id, 'type');
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    showImageMultiple() {
        let data = this.state.fileMultiple;
        let arrayImg = [];
        if (data.length > 0) {
            data.map((i, k) => {
                arrayImg.push(
                    <div className={`col-md-2`} style={{ position: 'relative' }} key={k}>
                        {
                            <Icon type={'close'} className={`cursorPointer removeImage`}
                                onClick={() => this.removeImage(i, k)} />
                        }
                        <img key={k}
                            src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${i.fileUri ? i.fileUri : i.fileUrl}`}
                            width={`100%`}
                            className={`cursorPointer img-thumbnail ml-3`} />
                    </div>
                )
            })
        }
        return arrayImg;
    }

    removeImage = (i, k) => {
        if (!i) return;
        const data = this.state.data;
        let oldArrayImages = this.state.fileMultiple;
        const images = (data.images ? data.images : []).filter(item => item !== i.fileName);
        let newOldArrayImages = [];
        if (oldArrayImages.length > 0) {
            oldArrayImages.filter(i2 => i2.fileName !== i.fileName && newOldArrayImages.push(i2));
        }
        data.images = images;
        this.setState({ fileMultiple: newOldArrayImages, data });
    };

    showThumbImage() {
        let data = this.state.thumbImage;
        if (this.state.thumbImage && Object.keys(this.state.thumbImage).length > 0) {
            return (
                <div className={`col-md-2`} style={{ position: 'relative' }}>
                    {
                        <Icon type={'close'} className={`cursorPointer removeImage`}
                            onClick={() => this.removeThumbImage()} />
                    }
                    <img
                        src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${data.fileUri ? data.fileUri : data.fileUrl}`}
                        width={`100%`}
                        className={`cursorPointer img-thumbnail ml-3`} />
                </div>
            )
        }
    }

    getThumbSources(thumbs) {
        return thumbs.filter(t => t && Object.keys(t).length > 0).map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.fileUri ? t.fileUri : t.fileUrl}`)
    }

    getImageThumbBySrc(src) {
        const founds = (this.state.fileMultiple || []).filter(item => (src || '').endsWith(item.fileUri ? item.fileUri : item.fileUrl))
        return founds && founds.length && founds[0]
    }

    removeThumbImage = () => {
        this.setState({
            data: merge(this.state.data, {
                thumbImage: ""
            }),
            thumbImage: {},
        })
    }
}

export default withTranslation()(VinWonderDetail);
